import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import AppProvider from "./context/main";
import HomePage from "./pages/HomePage/HomePage";
import StakeMuscleX from "./pages/StakeMuscleX/StakeMuscleX";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <Header />
          <Routes>
            <Route path="/" index={true} element={<StakeMuscleX />} />
            {/* <Route path='/stakePartTwo' element={}  /> */}
          </Routes>
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
